module.exports = __webpack_public_path__ + "static/media/annotation-button-off.410124d8.svg";